var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgHardwareEditIcon = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 40,
  height: 40,
  viewBox: "0 0 40 40",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 20,
  cy: 20,
  r: 20,
  fill: "#3988F9",
  fillOpacity: 0.1
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M27.7594 15.7318L24.268 12.2412C24.1519 12.1251 24.0141 12.033 23.8624 11.9702C23.7107 11.9073 23.5482 11.875 23.384 11.875C23.2198 11.875 23.0572 11.9073 22.9056 11.9702C22.7539 12.033 22.6161 12.1251 22.5 12.2412L12.8664 21.8748C12.7498 21.9905 12.6574 22.1281 12.5945 22.2798C12.5316 22.4315 12.4995 22.5942 12.5 22.7584V26.2498C12.5 26.5813 12.6317 26.8993 12.8661 27.1337C13.1005 27.3681 13.4185 27.4998 13.75 27.4998H26.875C27.0408 27.4998 27.1997 27.434 27.3169 27.3168C27.4342 27.1995 27.5 27.0406 27.5 26.8748C27.5 26.7091 27.4342 26.5501 27.3169 26.4329C27.1997 26.3157 27.0408 26.2498 26.875 26.2498H19.0094L27.7594 17.4998C27.8755 17.3837 27.9676 17.2459 28.0304 17.0942C28.0933 16.9426 28.1256 16.78 28.1256 16.6158C28.1256 16.4517 28.0933 16.2891 28.0304 16.1374C27.9676 15.9857 27.8755 15.8479 27.7594 15.7318ZM25 18.4912L21.5094 14.9998L23.3844 13.1248L26.875 16.6162L25 18.4912Z",
  fill: "#3988F9"
})));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgHardwareEditIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/hardwareEditIcon.5c60197a.svg";
export { ForwardRef as ReactComponent };